import { render, staticRenderFns } from "./FixedAssetCategoryView.vue?vue&type=template&id=6d3a25f4"
import script from "./FixedAssetCategoryView.vue?vue&type=script&lang=js"
export * from "./FixedAssetCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports